module.exports = __webpack_public_path__ + "static/slide-1-f1a4eb87d033e06b62bff08581e4f15f.png";